import {
    DocumentStatus,
    GenericObject,
    LocalizedString,
    Media,
    ReceiptAlert,
    Topic,
    copyFields,
    fixDates,
} from '@synergy/models';

import { Contact } from '../../../common/models/contact';
import { DemandAccount } from './demand-account';
import { DemandCompletionStatus } from './demand-completion-status';
import { DemandCustomer } from './demand-customer';
import { DemandItem } from './demand-item';
import { RegionWithId } from '../../../common/models/region';
import { User } from '../../../common/models/user';

export class Demand {
    public id!: number;
    public number!: string;
    public title!: LocalizedString;
    public description?: LocalizedString;
    public internalNote!: string;
    public noteToCustomer?: LocalizedString;
    public responsibleContact!: Contact;
    public status!: DocumentStatus;
    public enableExpirationNotifications!: boolean;
    public startDate!: Date;
    public endDate!: Date;
    public demandCustomers!: DemandCustomer[];
    public demandAccounts!: DemandAccount[];
    public demandItems!: DemandItem[];
    public netSurcharge!: number;
    public media!: Media[];
    public receiptAlert?: ReceiptAlert;
    public topics!: Topic[];
    public regions!: RegionWithId[];
    public completionStatus!: DemandCompletionStatus;
    public isScheduled!: boolean;
    public deliveryDateFrom!: Date;
    public deliveryDateTo!: Date;

    public createdAt!: Date;
    public createdBy?: User;
    public updatedAt?: Date;
    public updatedBy?: User;

    public static fromPlainObject(object: GenericObject): Demand {
        const demand = new Demand();

        copyFields(object, demand);

        if (object['responsibleContact']) {
            demand.responsibleContact = Contact.fromPlainObject(object['responsibleContact']);
        }

        if (object['demandCustomers']) {
            demand.demandCustomers = object['demandCustomers'].map(DemandCustomer.fromPlainObject);
        }

        if (object['demandItems']) {
            demand.demandItems = object['demandItems'].map(DemandItem.fromPlainObject);
        }

        if (object['createdBy']) {
            demand.createdBy = User.fromPlainObject(object['createdBy']);
        }

        if (object['updatedBy']) {
            demand.updatedBy = User.fromPlainObject(object['updatedBy']);
        }

        if (object['media']) {
            demand.media = object['media'].map(Media.fromPlainObject);
        }

        fixDates(demand, ['startDate', 'endDate', 'createdAt', 'updatedAt', 'deliveryDateFrom', 'deliveryDateTo']);

        return demand;
    }
}
